import BgImage from './components/bg-image/bg-image.vue'
import vueResource from 'vue-resource'
Vue.use(vueResource);

Vue.http.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;

Vue.directive('init', {
    bind: function (el, binding /*, vnode*/ ) {
        console.log(binding.value); //# This line is optional, of course.
    }
});

Vue.component('expertisePage', {
    components: {
        BgImage
    },
    props: [
        'pagedata',
        // '_perpage',
        // '_limit',
        // '_allitems'
    ],
    data() {
        return {
            items: this.pagedata ? this.pagedata.items.data : [],
            activeItem: 0
            // active_item: this.pagedata.items.data[0].id
            // categories: this.pagedata.categorie0s ? this.pagedata.categories : [],
            // allitems: this._allitems,
            // limit: this._limit ? this._limit : 1,
            // perpage: this._perpage,
            // filters: {
            //     'year': null
            // },
        }
    },
    computed: {},
    methods: {
        changeExpertise(expertise) {
            $('[id^=highlights]').collapse('hide');
            $(".btn-full").addClass("collapsed");
            this.activeItem = expertise;
        },
        toggleHighlights($event, target) {
            $(".btn-full").toggleClass("collapsed");
            $('#highlights-' + target).collapse('toggle');
        }
    },
});


// WEBPACK FOOTER //
// ./src/js/expertise.js